import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import API_BASE_URI from "../../../config/api.config"

export const jaagaGptSlice = createApi({
   reducerPath: "jaagaGpt-api",
   baseQuery: fetchBaseQuery({ baseUrl: API_BASE_URI }),
   tagTypes: ["jaagaGpt"],
   endpoints: (builder) => {
      return {
         postQuestion: builder.mutation({
            query: postData => {
               return {
                  url: "/gpt/chat",
                  method: "POST",
                  body: postData
               }
            },
            invalidatesTags: ["jaagaGpt"]
         })
      }
   }
})

export const { usePostQuestionMutation } = jaagaGptSlice
